export const SET_KEYSTORE_ITEM_SIGNAL =
  'edrolo/profiles/SET_KEYSTORE_ITEM_SIGNAL';
export const SET_KEYSTORE_ITEM_REQUEST =
  'edrolo/profiles/SET_KEYSTORE_ITEM_REQUEST';
export const SET_KEYSTORE_ITEM_FAILURE =
  'edrolo/profiles/SET_KEYSTORE_ITEM_FAILURE';
export const SET_KEYSTORE_ITEM_SUCCESS =
  'edrolo/profiles/SET_KEYSTORE_ITEM_SUCCESS';

export const setKeystoreItem = {
  signal: (key, value) => ({
    // `key` should be a string in the KEYSTORE_WHITELIST
    // `value` should be a string, number or boolean
    type: SET_KEYSTORE_ITEM_SIGNAL,
    payload: { key, value },
  }),
  request: (key, value) => ({
    type: SET_KEYSTORE_ITEM_REQUEST,
    payload: { key, value },
  }),
  failure: (errors, key, originalValue) => ({
    type: SET_KEYSTORE_ITEM_FAILURE,
    payload: { errors, key, originalValue },
  }),
  success: (key, value) => ({
    type: SET_KEYSTORE_ITEM_SUCCESS,
    payload: { key, value },
  }),
};
